import { request } from "../../utils/config"

export const GET_USER = async (id: string) => {
  const response = await request({
    url: `Users/${id}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
